import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import useFetch from '../../CustomHooks/useFetch';
import MessageBoxWithAction from '../MessageBoxWithAction';
import {isItTestEnvironment} from '../../Util/TestOrProd';

export default function SubscriptionForm(props) {
    const [companyName, setCompanyName] = useState('');
    const [companyNameError, setCompanyNameError] = useState('');
    const [addressLine1, setAddressLine1] = useState('');
    const [addressLine1Error, setAddressLine1Error] = useState('');
    const [addressLine2, setAddressLine2] = useState('');
    const [city, setCity] = useState('');
    const [cityError, setCityError] = useState('');
    const [country, setCountry] = useState('');
    const [countryError, setCountryError] = useState('');
    const [postcode, setPostcode] = useState('');
    const [postcodeError, setPostcodeError] = useState('');
    const classes = useStyles();
    const [getSessionIdHookResponse, getSessionIdHook] = useFetch();
    const [showMessage, setShowMessage] = useState(false);




    useEffect(
        () => {
            if (!Array.isArray(getSessionIdHookResponse)) {
                console.log(getSessionIdHookResponse);
                
                let clientId = isItTestEnvironment() ? 'pk_test_gpidSIs7ni3EYvuaeZCTCb2e00qiyEYjan':'pk_live_O8WpEPE6gJYh22WH2vHdtqZC00m5nYYhOO';
                console.log(clientId);
                var stripe = window.Stripe(clientId);
                
                stripe.redirectToCheckout({
                    sessionId: getSessionIdHookResponse.sessionId
                }).then(function (result) {
                    console.log(result.error.message);
                });

            }
        }, [getSessionIdHookResponse]
    )

    const getSessionId = () => {
        getSessionIdHook(
            {
                url: '/admin/stripe/create-session-id',
                method: 'POST',
                addTokenHeader: true,
                postData: {
                    companyName: companyName,
                    invoiceAddress: {
                        city: city,
                        country: country,
                        line1: addressLine1,
                        line2: addressLine2,
                        postalCode: postcode,
                        state: "",
                    }
                },
            }
        )
    }

    const submitForm = () => {
        let validated = true;


        if (companyName == '') {
            setCompanyNameError('Please enter your company name.');
            validated = false;
        }
        else {
            setCompanyNameError('');
        }


        if (addressLine1 == '') {
            setAddressLine1Error('Please enter your address line 1.')
            validated = false;
        }
        else {
            setAddressLine1Error('');
        }

        if (city == '') {
            setCityError('Please enter your city.')
            validated = false;
        }
        else {
            setCityError('');
        }

        if (country == '') {
            setCountryError('Please enter your country.')
            validated = false;
        }
        else {
            setCountryError('');
        }

        if (postcode == '') {
            setPostcodeError('Please enter your postcode.')
            validated = false;
        }
        else {
            setPostcodeError('');
        }

        if (validated) {
            setShowMessage(true);
        }
    }

    const okClicked = () => {
        getSessionId();
    }

    return (
        <div className={classes.root}>
            <div>Please check your company name and address which will appear on the invoice</div>
            <TextField id="companyName" label="Company Name" value={companyName} onChange={(e) => setCompanyName(e.target.value)} helperText={companyNameError} error={companyNameError == '' ? false : true} />
            <TextField id="addressLine1" label="Address Line 1" value={addressLine1} onChange={(e) => setAddressLine1(e.target.value)} helperText={addressLine1Error} error={addressLine1Error == '' ? false : true} />
            <TextField id="addressLine2" label="Address Line 2" value={addressLine2} onChange={(e) => setAddressLine2(e.target.value)} />
            <TextField id="city" label="City/Town" value={city} onChange={(e) => setCity(e.target.value)} helperText={cityError} error={cityError == '' ? false : true} />
            <TextField id="country" label="Country" value={country} onChange={(e) => setCountry(e.target.value)} helperText={countryError} error={countryError == '' ? false : true} />
            <TextField id="postcode" label="Postcode" value={postcode} onChange={(e) => setPostcode(e.target.value)} helperText={postcodeError} error={postcodeError == '' ? false : true} />
            <Button id="submitButton" variant="contained" color="primary" style={{ marginTop: '30px' }} onClick={submitForm}>
                Go to payment
            </Button>
            {
                showMessage ?
                    <MessageBoxWithAction ok={() => okClicked()} cancel={() => setShowMessage(false)}>
                        Now you will be redirected to Stripe to complete your payment.
                     </MessageBoxWithAction>
                    : null
            }
        </div>

    )



}


const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '300px',

        '&>div:nth-child(1)': {
            marginBottom : '30px',
        }
    },
});